/**
 * Отказ контракта или кошелька → текст для оператора.
 *
 * Раньше любая ошибка показывалась как «Ограничения на смарт-контракте» —
 * в том числе опечатка в имени функции, из-за которой удаление не работало
 * вообще. Здесь — причины, которые реально встречаются у `EmivnSalary`.
 */

const REVERT_REASONS: Record<string, string> = {
  'Employee already exists': 'Сотрудник с этим кошельком уже есть в контракте',
  'Employee does not exist': 'Сотрудника с этим кошельком нет в контракте',
  'Salary should be more than 0': 'Оклад должен быть больше нуля',
  'Unprofitable employee':
    'Контракт отклонил: штраф не может быть больше оклада с премией',
  'Insufficient contract balance': 'На контракте не хватает токенов на выплату',
};

const CUSTOM_ERRORS: Record<string, string> = {
  AccessControlUnauthorizedAccount:
    'У подключённого кошелька нет роли ADMIN_ROLE в контракте',
  EnforcedPause: 'Контракт на паузе',
};

type EthersError = {
  code?: string;
  reason?: string | null;
  shortMessage?: string;
  revert?: { name?: string; args?: unknown[] } | null;
  message?: string;
};

export function contractErrorMessage(error: unknown): string {
  const e = error as EthersError;

  if (e?.code === 'ACTION_REJECTED') {
    return 'Транзакция отклонена в кошельке';
  }

  if (e?.reason && REVERT_REASONS[e.reason]) {
    return REVERT_REASONS[e.reason];
  }

  if (e?.revert?.name && CUSTOM_ERRORS[e.revert.name]) {
    return CUSTOM_ERRORS[e.revert.name];
  }

  // panic 0x11 — переполнение. У `setEmployeeSalary` при премии больше штрафа
  // и у выплаты, когда штраф больше оклада с премией (см. docs контракта).
  if (e?.reason?.includes('0x11') || e?.shortMessage?.includes('0x11')) {
    return 'Контракт отклонил из-за переполнения: проверьте премию и штраф сотрудника (см. «Известные особенности» в доке контракта)';
  }

  if (e?.code === 'INSUFFICIENT_FUNDS') {
    return 'На кошельке не хватает BNB на газ';
  }

  return `Транзакция не прошла: ${e?.reason ?? e?.shortMessage ?? e?.message ?? 'неизвестная ошибка'}`;
}
